export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_01.01cbfc51.jpg";